import React from 'react';

import PaintPaletteIcon from '@atlaskit/icon/core/paint-palette';

export const LookAndFeelIconV2 = () => <PaintPaletteIcon label="" spacing="spacious" />;
